import React from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import FormFilter from '../../components/fragments/FilterDashboard/FormFilter';

interface ChartFilterProps {
  startDate: string;
  endDate: string;
  isVisible: boolean;
  downloadable?: boolean;
  loading?: boolean;
  onDownload?: () => void;
  onClose: () => void;
  onFilter: (data: {
    startDate: string;
    endDate: string;
    categoryId?: string;
  }) => void;
}

const ChartFilter: React.FC<ChartFilterProps> = ({
  downloadable,
  onDownload,
  loading,
  endDate,
  isVisible,
  onClose,
  startDate,
  onFilter
}) => {
  const handleFilter = (data) => {
    onFilter(data);
    onClose();
  };
  return (
    <ModalWrapper title="Filter" isVisible={isVisible} onClose={onClose}>
      <FormFilter
        onFilter={handleFilter}
        data={{
          startDate,
          endDate,
          businessUnit: '',
          subBusinessUnit: '',
          departement: ''
        }}
        type="inside-chart"
        downloadable={downloadable}
        onDownload={onDownload}
        loading={loading}
      />
    </ModalWrapper>
  );
};

export default ChartFilter;
